/**
 * PreviewHero — Hero section with title, subtitle, CTA buttons, and optional image
 */

interface PreviewHeroProps {
  data: {
    title?: string;
    subtitle?: string;
    primaryBtn?: string;
    secondaryBtn?: string;
    imageUrl?: string;
  };
  settings: {
    [key: string]: any;
  };
}

export function PreviewHero({ data, settings }: PreviewHeroProps) {
  return (
    <section className="preview-hero">
      <div className="preview-container">
        <div className="preview-hero__inner">
          <div className="preview-hero__content">
            <h1 className="preview-hero__title">{data.title}</h1>
            <p className="preview-hero__text">{data.subtitle}</p>
            <div className="preview-hero__actions">
              <button className="preview-btn preview-btn--primary">
                {data.primaryBtn}
              </button>
              <button className="preview-btn preview-btn--secondary">
                {data.secondaryBtn}
              </button>
            </div>
          </div>

          {data.imageUrl && (
            <div className="preview-hero__image">
              <img src={data.imageUrl} alt="Hero" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
